import { motion } from "framer-motion";
import { Phone, Mail, Timer } from "lucide-react";
import { EnquiryForm } from "./EnquiryForm";

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="relative scroll-mt-24 border-t border-border py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="mono-label flex items-center gap-3">
          <span className="inline-block h-0.5 w-10 bg-brass" />
          Talk To Us
        </p>
        <h2 className="mt-3 font-serif text-4xl font-black uppercase tracking-tight text-bone sm:text-5xl">
          Pricing, slots, <span className="text-brass">straight answers</span>
        </h2>
        <p className="mt-4 max-w-md text-base leading-relaxed text-sand">
          Latest pricing, colours in stock, next pre-order slots and bundle deals —
          ask anything. We reply within one working day.
        </p>

        <div className="mt-10 space-y-6">
          <a href="tel:07522364950" data-testid="contact-phone-link" className="group flex items-center gap-4">
            <span className="clip-corner-sm flex h-12 w-12 shrink-0 items-center justify-center bg-brass transition-colors group-hover:bg-brass-bright">
              <Phone className="h-5 w-5 text-white" />
            </span>
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-sand/60 uppercase">Call / WhatsApp</p>
              <p className="mt-0.5 font-serif text-2xl font-bold text-bone transition-colors group-hover:text-brass">
                07522 364950
              </p>
            </div>
          </a>
          <a href="mailto:ecobikecampsupp@gmail.com" data-testid="contact-email-link" className="group flex items-center gap-4">
            <span className="clip-corner-sm flex h-12 w-12 shrink-0 items-center justify-center bg-cyanx transition-colors group-hover:bg-brass">
              <Mail className="h-5 w-5 text-forest-deep transition-colors group-hover:text-white" />
            </span>
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-sand/60 uppercase">Email</p>
              <p className="mt-0.5 font-serif text-xl font-bold text-bone transition-colors group-hover:text-brass">
                ecobikecampsupp@gmail.com
              </p>
            </div>
          </a>
          <div className="flex items-center gap-4">
            <span className="clip-corner-sm flex h-12 w-12 shrink-0 items-center justify-center border-2 border-volt">
              <Timer className="h-5 w-5 text-volt" />
            </span>
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-sand/60 uppercase">Pre-order lead times</p>
              <p className="mt-0.5 font-serif text-xl font-bold text-bone">1–2 weeks kids · 2–4 weeks adult</p>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="border border-border bg-charcoal p-8 lg:p-10"
      >
        <p className="mb-5 font-mono text-[10px] font-bold tracking-[0.2em] text-cyanx uppercase">
          Quick enquiry — 60 seconds
        </p>
        <EnquiryForm testPrefix="contact-enquiry-form" />
      </motion.div>
    </div>
  </section>
);
